
const formScheme = {
    full_name: {
        type: 'string',
        length: 4
    },
    email: {
        type: 'email',
    },
    service_desired: {
        type: 'select',
        length: 2
    },
    phone_number: {
        type: 'number',
        length: 10
    },
    zip_code: {
        type: 'number',
        length: 5
    },
    privacy_policy: {
        type: 'boolean'
    }

}

module.exports = {
    formScheme: formScheme
}

